import * as React from "react";
import type { SVGProps } from "react";
export const SvgBrandsRiot = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <mask
      id="brands-riot_svg__a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#brands-riot_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 8.194 13.215 3 22 5.2v11.515l-3.635.447-1.45-8.225-.699.311.707 8.09-3.676.453-1.326-7.52-.692.307.646 7.38-3.635.447-1.205-6.836-.699.311.585 6.687-2.127.261L2 8.194Zm11.663 11.982-.185-1.047h.005L22 18.082v3.484l-8.337-1.39Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
